var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_setup.status === 'PERD')?_c(_setup.PerduView):(_setup.status === 'GAGNE')?_c(_setup.WinView):(_setup.status === 'WIN2')?_c(_setup.Win2View):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }